import type { FC, ReactElement } from 'react';

import { Icon, Icons } from '../../icons/';
import { L12nText } from '../../text/L12nText';
import styles from '../Popup.module.css';

export const ReconnectingPopup: FC = (): ReactElement => (
  <div className={`${styles.popup__reconnecting}`}>
    <Icon icon={Icons.Update} />
    <L12nText tk="CONNECT_SERVER" />
  </div>
);
